<template>
  <div class="create-acivity">
    <div class="acivity-left">
      <img src="../../assets/images/x.png" class="mobile-img">
      <img src="../../assets/images/liuhai.png" class="liuhai" alt="">
      <el-carousel class="scrol-image">
        <el-carousel-item v-for="item in imageArray" :key="item">
          <img :src="item" class="home-pic">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="acivity-right">
      <div style="width: 100%;height: 100%;">
        <div>
          <div class="tab-tit">
            <a @click="curId = 0" :class="{'cur':curId === 0}" style="border-radius: 5px 0 0 5px">基础设置</a>
            <a @click="curId = 1" :class="{'cur':curId === 1}" style="border-left: none;border-right: none;border-radius: 0">活动配置</a>
            <a @click="curId = 2" :class="{'cur':curId === 2}" style="border-radius: 0 5px 5px 0">奖品设置</a>
            <!--<div class="line"></div>-->
          </div>
        </div>
        <div v-if="curId === 0">
          <el-form :inline="true" ref="formInline" :rules="rules" class="acivity-content-form" :model="formInline" label-width="90px">
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="formInline.name" placeholder="请输入活动名称(不能超过50字)" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item prop="date" label="活动时间">
              <el-date-picker
                v-model="date"
                @change="dateChange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="活动封面" prop="cover_img">
              <el-upload
                class="avatar-uploader"
                name="file_upload"
                :action="uploadURL"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="formInline.cover_img" :src="formInline.cover_img" class="avatar-pic">
                <img v-else src="../../assets/images/prize-start.png" class="avatar-pic">
              </el-upload>
            </el-form-item>
            <p style="margin-left: 110px; margin-top: -30px;text-align: center;margin-bottom: 5px">请选择1M以下，支持上传jpg/png文件</p>
            <el-form-item label="活动说明" prop="description">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入内容"
                v-model="formInline.description">
              </el-input>
            </el-form-item>
            <el-form-item label="样式风格">
              <el-radio-group v-model="formInline.page_style" @change="pageStyleChange">
                <el-radio :label="1">扁平风格</el-radio>
                <el-radio :label="2">酷炫风格</el-radio>
              </el-radio-group>
            </el-form-item>
            <div style="text-align: center;width: 231px;margin: 0 auto;height: 36px">
              <el-button class="dialog-confirm-btn" type="primary" style="float: left;" @click="curId = 1">下一步</el-button>
            </div>
          </el-form>
        </div>
        <div v-if="curId === 1">
          <el-form ref="formInline" :rules="rules" :inline="true" class="acivity-setting-form" :model="formInline" label-width="110px">
            <el-form-item label="抽奖次数上限">
              <el-input-number v-model="formInline.draw_num" controls-position="right" @change="inputNumberChange"  :min="1" :max="9999"></el-input-number>
            </el-form-item>
            <el-form-item label="每日抽奖次数">
              <el-input-number v-model="formInline.everyday_draw_num" controls-position="right" :min="1" :max="everydayNumMax"></el-input-number>
            </el-form-item>
            <el-form-item label="中奖个数上限">
              <el-input-number v-model="formInline.lottery_num" controls-position="right" :min="1" :max="everydayNumMax"></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="标签:" class="picture-text-item">
              <tags-template v-model="formInline.tags" style="width: 180px;"></tags-template>
            </el-form-item> -->
            <el-form-item label="参与设置">
              <el-radio-group v-model="formInline.set_up">
                <el-radio :label="1">不设置</el-radio>
                <el-radio :label="2">仅会员参与</el-radio>
                <el-radio :label="3">提交表单</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="活动方式">
              <el-radio-group v-model="formInline.receive_way">
                <el-radio :label="2">线下活动</el-radio>
                <el-radio :label="1">线上活动</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否微信分享">
              <el-radio-group v-model="formInline.wechat_share">
                <el-radio :label="1">允许分享</el-radio>
                <el-radio :label="0">禁止分享</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="奖品数量显示">
              <el-radio-group v-model="formInline.show_num">
                <el-radio :label="0">不显示</el-radio>
                <el-radio :label="1">显示</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="关联公众号" prop="public_id" class="public">
              <el-select v-model="formInline.public_id" placeholder="请选择">
                <el-option
                  v-for="item in publicOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择客户来源" prop="source_id" class="public">
              <el-select filterable v-model="formInline.source_id" placeholder="请选择">
                <el-option
                  v-for="item in sources"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户来源说明" prop="source_content">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入内容"
                v-model="formInline.source_content">
              </el-input>
            </el-form-item>
            <el-form-item class="button-content">
              <el-button class="dialog-confirm-btn" type="primary" @click="curId = 2" style="margin-left: 10px;margin-right: 85px">下一步</el-button>
              <el-button class="dialog-cancel-btn" style="margin-left: 55px" @click="curId = 0">上一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="curId === 2">
          <el-form :inline="true" class="acivity-prize-form" :model="formInline" label-width="200px">
            <div class="new-add-setting">
              奖品设置至少1个，至多6个
              <el-button type="primary" style="margin-top: 3px;float: none" @click="addPrizeAction">新增</el-button>
            </div>
            <div class="new-add-table">
              <el-table
                :data="formInline.prize"
                border
                style=""
                class="table">
                <el-table-column
                  prop=""
                  label="奖品等级"
                  width="110">
                  <template slot-scope="scope">
                    <span>{{level[scope.$index]}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品类型"
                  width="150">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.prize_type" placeholder="请选择奖品类型">
                      <el-option
                        v-for="item in prizeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品内容"
                  width="180">
                  <template slot-scope="scope">
                    <el-input v-if="scope.row.prize_type === 1" v-model="scope.row.prize_name" placeholder="如:手机一部"></el-input>
                     <el-input v-if="scope.row.prize_type === 3" v-model="scope.row.prize_name" placeholder="请输入链接地址"></el-input>
                    <el-input-number v-if="scope.row.prize_type === 2 || scope.row.prize_type === 4" class="prize-count-special" v-model="scope.row.prize_money" controls-position="right" :min="1"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column
                  label="奖品编号"
                  width="">
                  <template slot-scope="scope">
                    <el-input v-if="scope.row.prize_type === 1" v-model="scope.row.prize_number" class="" style="width: 100%" placeholder="奖品编号"></el-input>
                    <span v-else>无需填写</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="中奖概率"
                  width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.probability" class="prize-percent" placeholder="">
                      <template slot="append">%</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="start"
                  label="奖品数量"
                  width="120">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.prize_num" class="prize-count" controls-position="right" :min="1" :max="9999"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column width="60" label="操作" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                      <div class="op-link">
                        <i class="" style="font-size: 14px;font-style: normal" @click="deleteRow(scope.$index, formInline.prize)">删除</i>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-form-item class="button-content">
              <el-button class="dialog-confirm-btn" style="margin-left: 10px" type="primary" @click="addActivityAction()">保存</el-button>
              <el-button class="dialog-cancel-btn" @click="curId = 1">上一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- <el-col style="text-align: center;">
          <el-button type="primary" style="float: left; margin-left: 45%;" @click="addActivityAction">保存</el-button>
        </el-col> -->
      </div>
    </div>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { getActivityDetails, modifyActivity, getWechatPublicListForNode, getCustomerSourceListForWepage } from '@/api/customer.js'
import tagsTemplate from '@/components/common/tags-template'
const cityOptions = ['扁平风格', '酷炫风格']
export default {
  name: 'add-activity',
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value) {
        return callback(new Error(''))
      }
    }
    return {
      tagsArray: [],
      curId: 0,
      date: [],
      tempArray: [require('../../assets/images/home-prize-0.png'), require('../../assets/images/home-prize-1.png'), require('../../assets/images/home-prize-2.png'), require('../../assets/images/home-prize-3.png'), require('../../assets/images/home-prize-4.png'), require('../../assets/images/home-prize-5.png')],
      tempArray1: [require('../../assets/images/home-prize-6.png'), require('../../assets/images/home-prize-7.png')],
      imageArray: [],
      level: ['一等奖', '二等奖', '三等奖', '四等奖', '五等奖', '六等奖'],
      formInline: {
        // name: '',
        // start_time: '',
        // end_time: '',
        // draw_num: 1,
        // everyday_draw_num: 1,
        // lottery_num: 1,
        // wechat_share: 0,
        // public_id: '',
        // cover_img: '',
        // description: '',
        // page_style: 1,
        // show_num: 0,
        // prize: [
        //   {
        //     prize_level: '',
        //     prize_type: 0,
        //     prize_name: '',
        //     prize_num: '',
        //     probability: ''
        //   }
        // ]
      },
      publicOptions: [],
      styles: cityOptions,
      num8: 1,
      tableData: [],
      prizeOptions: [
        {
          value: 1,
          label: '实物'
        },
        {
          value: 2,
          label: '红包'
        },
        {
          value: 3,
          label: '优惠券'
        },
        {
          value: 4,
          label: '积分'
        }
      ],
      everydayNumMax: 1,
      activityId: '',
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        date: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ],
        source_content: [
          { required: true, message: '请输入来源说明', trigger: 'blur' }
        ],
        source_id: [
          { required: true, message: '请选择客户来源', trigger: 'blur' }
        ],
        public_id: [
          { required: true, message: '请选择公众号', trigger: 'blur' }
        ],
        cover_img: [
          { required: true, message: '请输上传活动封面图', trigger: 'blur' }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        }
      }
    }
  },
  methods: {
    inputNumberChange(value) {
      this.everydayNumMax = this.formInline.draw_num
    },
    pageStyleChange() {
      if (this.formInline.page_style === 1) {
        this.imageArray = this.tempArray
      } else {
        this.imageArray = this.tempArray1
      }
    },
    deleteRow(index, rows) {
      if (this.formInline.prize.length <= 1) {
        _g.toastMsg('error', '至少要有一个奖项')
        return
      }
      rows.splice(index, 1)
    },
    addActivityAction() {
      for (var i = 0; i < this.formInline.prize.length; i++) {
        this.formInline.prize[i].prize_level = i + 1
      }
      modifyActivity(this.activityId, this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/activity-list')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    dateChange() {
      this.formInline.start_time = this.date[0]
      this.formInline.end_time = this.date[1]
    },
    addPrizeAction() {
      if (this.formInline.prize.length >= 6) {
        _g.toastMsg('error', '最多添加六个奖项')
        return
      }
      this.formInline.prize.push({
        prize_level: '',
        prize_type: 1,
        prize_name: '',
        prize_number: '',
        prize_num: '',
        probability: ''
      })
    },
    // 会员权益图标
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.cover_img = res.data.path
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        _g.toastMsg('error', '上传头像图片大小不能超过 1MB!')
      }
      const check = (isJPG && isLt2M) || (isPNG && isLt2M)
      if (check) {
        _g.toastMsg('success', '正在上传')
      }
      return check
    },
    getPublicList() {
      getWechatPublicListForNode().then((res) => {
        for (let item of res.data.data.list) {
          this.publicOptions.push({
            label: item.nick_name,
            value: item.id
          })
        }
      })
    },
    // 获取客户来源
    getSourceList() {
      getCustomerSourceListForWepage(1).then((res) => {
        if (res.data.code === 0) {
          this.sources = res.data.data.list
        }
      })
    },
    getData() {
      this.activityId = this.$route.query.id
      getActivityDetails(this.activityId).then(res => {
        this.formInline = res.data.data
        this.date = [this.formInline.start_time, this.formInline.end_time]
        this.everydayNumMax = this.formInline.draw_num
        if (this.formInline.page_style === 1) {
          this.imageArray = this.tempArray
        } else {
          this.imageArray = this.tempArray1
        }
      })
    }
  },
  components: {
    tagsTemplate
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created() {
    // this.imageArray = this.tempArray
    this.getPublicList()
    this.getSourceList()
    this.getData()
  }
}
</script>

<style scoped>
  .create-acivity {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    width: calc(100% - 40px);
    background: #fff;
    margin: 20px auto 0;
    overflow-x: hidden;
  }
  .acivity-left {
    width: 43%;
    height: 800px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    position: relative;
  }
  .acivity-right {
    width: 57%;
    height: 800px;
    align-items: center;
    display: flex;
    justify-content: center;
    margin-left: -30px;
  }
  .mobile-img {
    position: absolute;
  }
  .scrol-image {
    /*margin-left: 130px;*/
  }
  .liuhai{
    position: absolute;
    top: 113px;
    z-index: 100;
  }
  .scrol-image, .scrol-image .el-carousel__item  {
    height: 575px;
    width: 266px;
    border-radius: 26px;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .tab-tit {
    width: 394px;
    margin: 90px auto 0;
    margin-bottom: 20px;
    overflow: hidden;
  }
  .tab-tit .cur {
    background: #1890FF;
    color: #fff;
  }

  .tab-tit .line, .saveData .line{
    width:90%;
    margin: 2% auto;
    border:0.5px dashed #d2d2d2;
  }
  .tab-tit a {
    cursor: pointer;
    display:block;
    float: left;
    width: 130px;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
    text-align: center;
    background: #fff;
    color: #333;
    border:1px solid #1890FF;
  }
  .acivity-content-form {
    width: 460px;
    text-align: center;
    margin: auto;
  }
  .acivity-setting-form {
    width: 460px;
    text-align: center;
    margin: auto;
  }
  .acivity-prize-form {
    /*text-align: center;*/
    /*margin: 0 auto;*/
    width: 100%;
  }
  .acivity-content-form .el-form-item__content {
    width: 300px;
  }
  .acivity-content-form p {
    margin: 0px;
    line-height: 20px;
    text-align: left;
    color: #999;
    font-size: 12px;
  }
  .prize-count {
    width: 100px;
  }
  .prize-count-special{
    width: 160px;
  }
  .prize-percent {
    width: 80px;
  }
  .prize-percent .el-input {
    width: 60px;
  }
  .prize-percent .el-input__inner {
    width: 60px;
    height: 36px;
  }
  .home-pic {
    width: 100%;
    height: 100%;
  }
  .avatar-pic {
    height:110px;
    width: 327px;
    display: block;
  }
  .button-content {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: row;
    margin-top: 20px;
  }
  .new-add-setting {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  .new-add-table {
    width: 100%;
    margin-top: 40px;
  }
  @media screen and (min-width: 1600px) {
    .acivity-left {
      width: 35%;
      justify-content: flex-end;
      margin-right: 100px;
    }
    .mobile-img{
      right: -23px;
    }
    .liuhai{
      right: 60px;
    }
  }
</style>
